import React, { useState } from 'react';
import { Collapse } from 'react-bootstrap';
import { useSelector } from "react-redux";
import { Link } from 'react-router-dom';
import leftarrow from '../../../../assets/images/left-arrow.svg';
import { injectIntl } from 'react-intl';
import { setControlNumber } from '../../../../Utils/Utility';
import { getFormattedDate } from '../../../Common/DateUtils';

function UnbilledDetails({ intl, ...props }) {
    const id = props.match.params.id;
    const unbilledData = useSelector(state => state.unbilled.unbilledPo);
    const loads = unbilledData.loads;
    const load = loads.find(load => load.load_id === id)
    const [showText, setShowText] = useState(false);
    const { formatMessage } = intl;
    let controlNumber = load.load_control_num;
    
    if (controlNumber) {
        setControlNumber(controlNumber);
    }
    
    const handleCollapse = () => {
        setShowText(!showText);
    }

    return (

        <div className="content-page">
            <div className="content">
                <div className="contest_input_block">
                    <div className="contest_preview">
                        <div className="top_header_bar">
                            <div className="row">
                                <div className="col-sm col-xl-4 d-flex align-items-center p-0">
                                    <Link to='/' style={{ marginRight: '15px' }}>
                                        <img src={leftarrow} className="bakc-arrow" />
                                    </Link>
                                    <h3 className="m-0 h3-heading" title={load.load_control_num}> {load.load_control_num}
                                        <br />
                                        <label style={{ fontSize: '18px', margin: '0' }} className="header-subtitle" title="Unbilled">{formatMessage({ id: "app.awaiting_header" })}</label>
                                    </h3>
                                </div>
                            </div>
                        </div>

                        <div className="container_block" style={{ padding: '40px' }}>
                            <div className="row">
                                <div className="col-sm-6 col-xxl-4">


                                    <div className="row">
                                        <div className="form-group col-sm-6">
                                            <span className="gray_label">{formatMessage({ id: "app.control_number" })}</span>
                                            <p>{load.load_control_num}</p>
                                        </div>

                                    </div>
                                    <div className="row">
                                        <div className="form-group col-sm-6">
                                            <span className="gray_label">{formatMessage({ id: "app.location" })}</span>
                                            <p>{load.location}</p>
                                        </div>
                                    </div>

                                    <div className="row">
                                        {load.unload_start_time &&
                                            <div className="form-group col-sm-6">
                                                <span className="gray_label">{formatMessage({ id: "app.unloading_started" })}</span>
                                                <p>{getFormattedDate(load.unload_start_time)}</p>
                                            </div>
                                        }
                                    </div>
                                    <div className="row">
                                        {load.appointment_time &&
                                            <div className="form-group col-sm-6">
                                                <span className="gray_label">{formatMessage({ id: "app.appointment_time" })}</span>
                                                <p>{getFormattedDate(load.appointment_time)}</p>
                                            </div>
                                        }
                                    </div>
                                    <div className="row">
                                        {load.dock_name &&
                                            <div className="form-group col-sm-6">
                                                <span className="gray_label">{formatMessage({ id: "app.dock" })}</span>
                                                <p>{load.dock_name}</p>
                                            </div>
                                        }
                                    </div>

                                </div>
                                <div className="col-sm-6">
                                    <div className="row">
                                        <div className="form-group col-sm-6">
                                            <span className="gray_label">{formatMessage({ id: "app.po" })}</span>

                                            {!showText ?
                                                <>
                                                    {load.pos.slice(0, 4).map((po, index) => {
                                                        return (
                                                            <p key={index}>{po.po_number}</p>
                                                        )
                                                    })}
                                                    {load.pos.length > 4 &&
                                                        < a href="javascript:void(0);" onClick={handleCollapse} > {formatMessage({ id: "app.see_more" })}</a>
                                                    }
                                                </>
                                                :
                                                <>

                                                    <Collapse in={showText}>
                                                        <div>
                                                            {load.pos.map((po, index) => {
                                                                return (
                                                                    <p key={index}>{po.po_number}</p>
                                                                )
                                                            })}
                                                        </div>
                                                    </Collapse>
                                                    {load.pos.length > 4 &&
                                                        < a href="javascript:void(0);" onClick={handleCollapse} > {formatMessage({ id: "app.see_less" })}</a>
                                                    }
                                                </>
                                            }

                                        </div>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div >

    )
}

export default injectIntl(UnbilledDetails);
